export default __webpack_public_path__ + "static/media/solo.11177e72.png";